import React, { Component } from "react";
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import $ from 'jquery';
import PatientAdmissionTabSettings from "../projectmgmt/PatientAdmissionTabSettings";
import ReportsTabSettings from "../projectmgmt/ReportsTabSettings";
import SurveyTabSettings from "../projectmgmt/SurveyTabSettings";
import JournalTabSettings from "../projectmgmt/JournalTabSettings";
import LiveExperience from "../projectmgmt/LiveExperience";
import AdminNavigationBar from '../projectmgmt/AdminNavigationBar';
import AIAgentTabSettings from "../projectmgmt/AIAgentTabSettings";
import logout from "../login/Logout";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css


class HamburgerMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showStaff: false,
      showPhysicainRoleView: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  toggleMenu() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  }

  closeMenu() {
    this.setState({
      isOpen: false,
    });
  }

  componentDidMount() {
    var thisController = this;
    var userDetails = localStorage.getItem("user_details");
    if(!userDetails) return;
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    if (userRole == 'PROCEDURE_ADMIN') {
      thisController.state.showStaff = true;
      thisController.setState(thisController.state);
    } else if (userRole == 'PHYSICIAN') {
      thisController.state.showPhysicainRoleView = true;
      thisController.setState(thisController.state);
    }
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/my-jeeva/projectmgmt/";
      var path1 = window.origin + "/my-jeeva/projectmgmt";
      if (currentPath == path || currentPath == path1) {
        $("#records").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/reports')) {
        $("#reports").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/survey')) {
        $("#survey").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/journal')) {
        $("#journal").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/ai-agent')) {
        $("#live-experience").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/patient-admission')) {
        $("#patient-admission").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/about')) {
        $("#about-us-tab").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/about-me')) {
        $("#about-me").addClass('activemenu');
      } else if (currentPath.includes('/projectmgmt/contact-us')) {
        $("#contact-us").addClass('activemenu');
      }
      $("#records,#reports,#live-experience,#patient-admission,#about-me,#about-us-tab,#survey,#contact-us,#journal")
        .on("click", function () {
          $("#records,#reports,#live-experience,#patient-admission,#about-me,#about-us-tab,#survey,#contact-us,#journal")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

        })
      $("#records").on("click", function () {
        $("#healthsystems,#hospital,#serviceline,#procedure,#users")
          .removeClass('active');
        $("#healthsystems").addClass('active');
      })

      $("#records").on("click", function () {
        $("#healthsystems,#hospital,#serviceline,#procedure,#staff")
          .removeClass('active');
        $("#healthsystems").addClass('active');
      })

    })();


  }
  openLogoutPopUp = () => {
   
    confirmAlert({
      title: 'Confirm to Logout',
      message: 'Are you sure you want to logout ? ',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            logout();
            // Toggle isOpen after logout
            this.setState({ isOpen: false });
          }
        },
        {
          label: 'No',
        }
      ]
    });
  }

  render() {
    const { isOpen } = this.state;
    return (
      <Router basename={window.contextPath}>
        <div className="hamburger-menu">
          <div className={`menu-items ${isOpen ? "open" : ""}`}>
            <div className="menu-link-wrap">
              <Link to={this.state.showStaff ? "/projectmgmt/staff" : "/projectmgmt"}>
                <li id="records" className="menu-link" >
                  <span onClick={this.closeMenu}>Administration</span>
                </li>
              </Link>
              <Link to ="/projectmgmt/patient-admission">
              <li id="patient-admission" className="menu-link" >
                <span onClick={this.closeMenu}>Patient Admissions</span>
              </li>
              </Link>
              <Link to="/projectmgmt/survey">
                <li id="survey" className="menu-link">
                  <span onClick={this.closeMenu}>Survey</span>
                </li>
              </Link>
              <Link to="/projectmgmt/journal">
                <li id="journal" className="menu-link">
                  <span onClick={this.closeMenu}>Journal</span>
                </li>
              </Link>
              <Link to="/projectmgmt/reports">
                <li id="reports" className="menu-link">
                  <span onClick={this.closeMenu}>Dashboard</span>
                </li>
              </Link>
              <Link to="/projectmgmt/ai-agent">
                <li id="live-experience" className="menu-link" >
                  <span onClick={this.closeMenu}>AI Agent</span>
                </li>
              </Link>
              <br/>
              <br/>
              <li id="live-experience" className="menu-link" >
                  <span onClick={() => this.openLogoutPopUp()}>Logout</span>
                </li>

              {/* <Link to="/projectmgmt/about">
                  <li id="about-us-tab" className="menu-link" >
                  
                    <span onClick={this.closeMenu}>About Us</span>
                  </li>
                </Link>
                <Link to="/projectmgmt/about" >
                  <li id="about-me" className="menu-link" >
                    <span onClick={this.closeMenu}>About Me</span>
                  </li>
                </Link> */}
              <div className="close-wrap">
                {isOpen && (
                  <span className="close" onClick={this.closeMenu} style={{ color: "white", opacity: 1 }}>
                    X
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="menu" onClick={this.toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>

          <Switch>
            <Route path="/projectmgmt/patient-admission" component={PatientAdmissionTabSettings}></Route>
            <Route path="/projectmgmt/reports" component={ReportsTabSettings}></Route>
            <Route path="/projectmgmt/survey" component={SurveyTabSettings}></Route>
            <Route path="/projectmgmt/journal" component={JournalTabSettings}></Route>
            {/* <Route path="/projectmgmt/patient-app" component={LiveExperience}></Route> */}
            <Route path="/projectmgmt/ai-agent" component={AIAgentTabSettings}></Route>
            <Route path="/projectmgmt" component={AdminNavigationBar}></Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default HamburgerMenu;



// WEBPACK FOOTER //
// src/my-jeeva/header/HamburgerMenu.js